export enum ECheckServiceErrorCode {
  /** неверный запрос */
  badRequest = 'badRequest',
  /** неизвестная ошибка на сервере */
  fatalError = 'fatalError',
  /** токен устарел */
  tokenExpired = 'token_expired',
}
